import { UserCompanyInfo } from './usercompanyinfo';

export class UserJobHistory {
  public function!: string;
  public jobHistoryId!: number;
  public startDTTM!: number;
  public endDTTM!: any;
  public startDTTMText!: string;
  public endDTTMText!: string;
  public currentJob: boolean = false;
  public jobRole!: string;
  public companyInfo: UserCompanyInfo = new UserCompanyInfo();
  public fullTimeJob: boolean = true;
  public reasonId: number = 0;
  public supervisorName!: string;
  public supervisorPhoneNum!: string;
  public contactSupervisor: boolean = false;
  public jobHistoryCustomData: any = {};
  public agency!: string;
}
